import React from "react";

const NotSure = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/2000/xlink"
    >
        <path
            d="M3.277 8.16 9.32 2.138a.473.473 0 0 1 .618-.044l.805.602a1.41 1.41 0 0 1 .523 1.477l-1.09 4.262h6.045c.501 0 .982.199 1.336.552.354.352.553.831.553 1.33v1.98c0 .246-.048.49-.142.717l-2.923 7.07a.941.941 0 0 1-.873.583H3.944A.946.946 0 0 1 3 19.726V8.825c0-.25.1-.489.277-.665ZM32.946 27.547 26.9 33.855a.458.458 0 0 1-.618.046l-.805-.63a1.476 1.476 0 0 1-.486-.692 1.54 1.54 0 0 1-.037-.856l1.09-4.465H20a1.85 1.85 0 0 1-1.336-.577 2.016 2.016 0 0 1-.553-1.394v-2.074c0-.258.048-.513.142-.751l2.923-7.407a.979.979 0 0 1 .348-.444.917.917 0 0 1 .525-.167h10.229c.25 0 .49.104.668.29.177.184.276.435.276.696v11.42c0 .261-.1.512-.276.697Z"
            className="u_fill"
            fill={fill}
        />
    </svg>
);

export default NotSure;


